'use client';
import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { id: 'stat-users', value: '2,400,000+', label: 'Registered Players', color: '#A78BFA' },
  { id: 'stat-activities', value: '500+', label: 'Activity Types', color: '#06B6D4' },
  { id: 'stat-prizes', value: '$8.2M+', label: 'Prizes Awarded', color: '#F59E0B' },
  { id: 'stat-countries', value: '78', label: 'Countries', color: '#10B981' },
  { id: 'stat-professions', value: '50+', label: 'Professions', color: '#F43F5E' },
  { id: 'stat-daily', value: '14,200+', label: 'Daily Competitions', color: '#A78BFA' },
];

export default function StatsBar() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <div ref={ref} className="py-12 border-y" style={{ borderColor: 'var(--border)', background: 'rgba(17, 24, 39, 0.5)' }}>
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-6">
          {stats?.map((stat, i) => (
            <div
              key={stat?.id}
              className="text-center"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(16px)',
                transition: `opacity 500ms ease ${i * 80}ms, transform 500ms ease ${i * 80}ms`,
              }}
            >
              <p className="font-extrabold mb-1" style={{ fontSize: '28px', color: stat?.color, fontVariantNumeric: 'tabular-nums' }}>
                {stat?.value}
              </p>
              <p className="text-sm font-medium" style={{ color: 'var(--muted-foreground)' }}>{stat?.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}